import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { PolicyWithBranches } from '../../../commonTypes/organization.types';

const useHttpGetPolicyByIdOnMount = (id?: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isReady, setIsReady] = useState<boolean>(false);
    const [policy, setPolicy] = useState<PolicyWithBranches>();

    useEffect(() => {
        if (id) {
            const { exec, abort } = organizationApi.getPolicy({
                params: { id },
                onSuccess: res => {
                    setPolicy(res.body);
                },
                onError: error => error,
                onFinally: () => setIsReady(true),
            });
            exec();
            return abort;
        }
    }, [id]);

    return { policy, isReady };
};

export default useHttpGetPolicyByIdOnMount;
